<div class="flex grow md:flex-row flex-col bg-green-0">
  <div class="flex-1 flex flex-col items-center justify-center p-4">
    <div class="flex flex-col items-center justify-center md:items-start w-full md:w-auto">
      <div>
        <img src="assets/images/logo-enerix.svg" alt="Enerix logo" class="mx-auto mt-8 md:mx-0" />
        <ng-content select="header"></ng-content>
      </div>
      <ng-content select="content"></ng-content>
    </div>
  </div>
  <div class="flex flex-1 items-center justify-center">
    <img
      [src]="imageSrc()"
      [alt]="imageAlt()"
      [ngClass]="{
        'w-full h-full': isImageFullSize(),
        'w-9/12 h-9/12 rounded-lg mb-10 md:mb-0': !isImageFullSize(),
        'shadow-xl': useShadow()
      }"
    />
  </div>
</div>
